import { useEffect, useState } from 'react';

/** Delays reflecting `value` until it has stopped changing for `delayMs` — used for search-as-you-type. */
export function useDebouncedValue<T>(value: T, delayMs = 250): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
